import { newClientUid } from './chatSync';

export const CHAT_BATCH_SIZE = 10;
// Limits are per file. Selection length is not limited.
export const CHAT_FILE_SIZE = 2 * 1024 * 1024 * 1024;
export const CHAT_PREVIEW_SIZE = 32 * 1024 * 1024;
// Bound temporary multipart storage without rejecting a multi-file selection.
export const CHAT_BATCH_BYTES = CHAT_FILE_SIZE;

export function validateChatFiles(files) {
  const large = files.find(file => file.size > CHAT_FILE_SIZE);
  if (large) throw new Error(`Файл «${large.name}» превышает 2 ГиБ`);
}

export function splitChatFiles(files) {
  const batches = [];
  let batch = [], bytes = 0;
  for (const file of files) {
    if (batch.length && (batch.length === CHAT_BATCH_SIZE || bytes + file.size > CHAT_BATCH_BYTES)) {
      batches.push(batch); batch = []; bytes = 0;
    }
    batch.push(file); bytes += file.size;
  }
  if (batch.length || !batches.length) batches.push(batch);
  return batches;
}

// File objects stay in memory. Only one batch is uploaded at a time.
export function createMessageQueue({ content = '', files = [], mentions = [], replyTo = null }) {
  validateChatFiles(files);
  const batches = splitChatFiles(files).map(batch => ({ uid: newClientUid(), files: batch }));
  return {
    content, files: files.slice(), mentions: mentions.map(m => ({ kind: m.kind, id: m.id })),
    replyTo, batches, next: 0, running: false, error: '', sentFiles: 0,
  };
}

export async function runMessageQueue(job, { send, isActive = () => true, onMessage, onChange }) {
  if (job.running) return false;
  job.running = true;
  job.error = '';
  onChange?.();
  try {
    while (job.next < job.batches.length && isActive()) {
      const index = job.next;
      const batch = job.batches[index];
      const fd = new FormData();
      fd.append('content', index === 0 ? job.content : '');
      fd.append('client_uid', batch.uid);
      batch.files.forEach(file => fd.append('attachments', file));
      if (job.replyTo?.id) fd.append('reply_to_id', job.replyTo.id);
      // A caption and its mentions belong only to the first message.
      if (index === 0 && job.mentions.length) fd.append('mentions', JSON.stringify(job.mentions));
      const message = await send(fd);
      if (!message?.id) throw new Error('Сервер не подтвердил отправку сообщения');
      // Advance BEFORE UI callbacks. Rendering failures must not resend files.
      job.next += 1;
      job.sentFiles += batch.files.length;
      try { onMessage?.(message); } catch (error) { console.error('Chat queue display:', error); }
      onChange?.();
    }
    return job.next === job.batches.length;
  } catch (error) {
    const detail = error?.response?.data?.detail || error?.response?.data?.error || error?.message;
    job.error = typeof detail === 'string' ? detail : 'Не удалось отправить файлы';
    return false;
  } finally {
    job.running = false;
    onChange?.();
  }
}
